import React from "react";
import styled from "styled-components";
import { useIntl } from "gatsby-plugin-intl";
import { graphql } from "gatsby";
import get from "lodash/get";

const StyledWrapper = styled.div`
  width: 100%;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.color[props.backgroundColor]};
  color: ${(props) => props.theme.color[props.textColor]};
  ${(props) => props.theme.responsive.mobile} {
    padding: 3rem;
  }
`;

const StyledContentBox = styled.div`
  padding: 1rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${(props) => props.theme.responsive.mobile} {
    padding: 2rem 4rem;
  }
`;

const StyledTitle = styled.div`
  font-size: 0.9rem;
  font-weight: bold;
  text-transform: uppercase;
`;

const StyledDescription = styled.div`
  opacity: 0.6;
  font-size: 0.8rem;
  font-weight: normal;
  text-align: center;
  margin: 0.3rem 0 1rem 0;
  ${(props) => props.theme.responsive.desktop} {
    width: 50%;
  }
`;

const StyledUnderline = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${(props) => props.theme.color.grey};
`;

const StyledLogoWrapper = styled.div`
  display: flex;
  margin-top: 0.6rem;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;

const StyledLogo = styled.img`
  margin: 0 0.4rem;
  width: 3.6rem;
  height: 3.6rem;
  object-fit: contain;
`;

export default function ShortPress({
  title,
  description,
  logos,
  textColor,
  backgroundColor,
  ...props
}) {
  const intl = useIntl();
  return (
    <StyledWrapper
      textColor={get(textColor, "color", undefined)}
      backgroundColor={get(backgroundColor, "color", undefined)}
    >
      <StyledContentBox>
        {title && <StyledTitle>{title[intl.locale]}</StyledTitle>}
        {description && (
          <StyledDescription>{description[intl.locale]}</StyledDescription>
        )}
        <StyledLogoWrapper>
          {logos.map((logo, i) => (
            <StyledLogo key={i} src={logo.url} />
          ))}
        </StyledLogoWrapper>
      </StyledContentBox>
    </StyledWrapper>
  );
}

export const query = graphql`
  fragment shortPressModal on STRAPI_ComponentPressShortPress {
    __typename
    id
    title {
      en
      es
      it
    }
    description {
      en
      es
      it
    }
    logos {
      url
    }
    textColor {
      color
    }
    backgroundColor {
      color
    }
  }
`;
